import React from "react";

interface NationalityContextType {
  nationality: string;
  setNationality: (_: string) => void;
  isKorean: boolean;
}

export const NationalityContext = React.createContext<NationalityContextType>(null!);
